"use client";
import React, { useContext } from "react";
import styles from "./footerLatest.module.scss";
import Image from "next/image";
import Link from "next/link";
import Newsletter from "../Newsletter";
import { GlobalContext } from "../context/Global";

const FooterLatest = () => {
  const { isCookiePopup, setCookiePopup } = useContext<any>(GlobalContext);
  return (
    <div className={styles.footerWrap}>
      <div className={`${styles.container} container`}>
        <div className={styles.topLayer}>
          <div className={styles.intro}>
            <div className={styles.logo}>
              <Image
                src={"/assets/logo/logo-light.svg"}
                fill
                alt="cubet light logo"
              />
            </div>
            <ul className={styles.location}>
              <li>
                <Link
                  href="/contact-us#global"
                  className="d-flex align-items-center hover-undeline text-nowrap"
                >
                  <span className={styles.icon}>
                    <Image
                      src="/assets/icons/atlanta.svg"
                      fill
                      priority={false}
                      alt="Cubet US Address"
                      className="img-fluid"
                    />
                  </span>
                  <span className={styles.text}>Atlanta, US</span>
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-us#global"
                  className="d-flex align-items-center hover-undeline text-nowrap"
                >
                  <span className={styles.icon}>
                    <Image
                      src="/assets/icons/london-flag.svg"
                      fill
                      priority={false}
                      alt="Cubet US Address"
                      className="img-fluid"
                    />
                  </span>
                  <span className={styles.text}>London, UK</span>
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-us#global"
                  className="d-flex align-items-center hover-undeline text-nowrap"
                >
                  <span className={styles.icon}>
                    <Image
                      src="/assets/icons/india-flag.svg"
                      fill
                      priority={false}
                      alt="Cubet US Address"
                      className="img-fluid"
                    />
                  </span>
                  <span className={styles.text}>Kochi, India</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.newsletter}>
            <Newsletter />
          </div>
        </div>
        <div className={styles.middleWrapper}>
          <div className={styles.connectWrapper}>
            <h4 className={styles.des}>
              <span>Help us serve</span> more clients like you. Join <Link href={'https://cubettech.com/refer-us/'} className={styles.special}>Cubet Connections</Link> to grow and lead
            </h4>
            <div className={styles.social}>
              <span className={styles.socialTitle}>Our Socials</span>
              <Link
                prefetch={false}
                href="https://www.facebook.com/CubetTech/"
                target="_blank"
                rel="nofollow"
              >
                <Image
                  src="/assets/icons/facebook.svg"
                  width={24}
                  height={24}
                  alt="facebook"
                  className="img-fluid"
                />
              </Link>
              <Link
                prefetch={false}
                href="https://twitter.com/CubetTech"
                target="_blank"
                rel="nofollow"
              >
                <Image
                  src="/assets/icons/twitter-new1.png"
                  width={20}
                  height={20}
                  alt="twitter"
                  className="img-fluid"
                />
              </Link>
              <Link
                prefetch={false}
                href="https://www.linkedin.com/company/cubet-technologies"
                target="_blank"
                rel="nofollow"
              >
                <Image
                  src="/assets/icons/linkedin.svg"
                  width={24}
                  height={24}
                  alt="linkedin"
                  className="img-fluid"
                />
              </Link>
              <Link
                prefetch={false}
                href="https://www.instagram.com/cubettechnolabs/"
                target="_blank"
                rel="nofollow"
              >
                <Image
                  src="/assets/icons/instagram.svg"
                  width={24}
                  height={24}
                  alt="instagram"
                  className="img-fluid"
                />
              </Link>
            </div>
          </div>
          <div className={styles.quickLinks}>
            <div className={styles.item}>
              <h3 className={styles.title}>Our Services</h3>
              <ul>
                <li>
                  <Link prefetch={false} href="/services/web-app-development">
                    Web Development
                  </Link>
                </li>
                <li>
                  <Link
                    prefetch={false}
                    href="/services/mobile-app-development"
                  >
                    App Development
                  </Link>
                </li>
                <li>
                  <Link
                    prefetch={false}
                    href="/services/artificial-intelligence-consulting"
                  >
                    Al Development
                  </Link>
                </li>
                <li>
                  <Link
                    prefetch={false}
                    href="/services/custom-product-engineering"
                  >
                    Product Development
                  </Link>
                </li>
                <li>
                  <Link
                    prefetch={false}
                    href="/services/enterprise-solution-integration"
                  >
                    Enterprise Solution Integration
                  </Link>
                </li>
              </ul>
            </div>
            <div className={`${styles.item} ${styles.industry}`}>
              <h3 className={styles.title}>Industries</h3>
              <ul>
                <li>
                  <Link prefetch={false} href="/industries/Healthcare/">
                    Healthcare
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/industries/Insurance/">
                    BFSI
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/industries/Education/">
                    Edtech / eLearning
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/industries/Hospitality/">
                    Hospitality
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/industries/enterprise-products-and-saas/">
                    Enterprise Products and SaaS
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/industries/retail/">
                    Retail
                  </Link>
                </li>
              </ul>
            </div>
            <div className={styles.item}>
              <h3 className={styles.title}>Explore</h3>
              <ul>
                <li className={styles.refer}>
                  <Link prefetch={false} href="/refer-us">
                    Refer
                    <span className={styles.icon}></span>
                    <span className={styles.text}><Image
                      src="/assets/homePage/refer.svg"
                      fill
                      loading="lazy"
                      alt="external link"
                    /></span>
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/resources/blog">
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/resources/whitepapers">
                    Whitepapers
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/resources/case-studies">
                    Case studies
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/resources/insights">
                    Insights
                  </Link>
                </li>
                <li>
                  <Link prefetch={false} href="/cubet-career">
                    Careers
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.copyRight}>
          <div className={styles.copyRightText}>
            <span>© 2025 Cubet</span>
          </div>
          <ul className={styles.copyRightLinks}>
            <li>
              <Link prefetch={false} href="/privacy-policy">
                Privacy Policy
              </Link>
              {/* <div className="position-absolute-line"></div> */}
            </li>

            <li>
              <Link prefetch={false} href="/cookie-policy">
                Cookies
              </Link>
              <div></div>
            </li>

            <li>
              <button
                onClick={() => setCookiePopup(!isCookiePopup)}
              >
                Cookie Settings
              </button>
              <div className="position-absolute-line"></div>
            </li>

            <li>
              <Link prefetch={false} href="/terms-conditions">
                Terms and Conditions
              </Link>
              <div className="position-absolute-line"></div>
            </li>
            <li>
              <Link prefetch={false} href="/cubet-connections-program">
                Cubet Connections: T&C
              </Link>
              <div className="position-absolute-line"></div>
            </li>
          </ul>
        </div>
        <div className={styles.reviewLayer}>
          <div className={styles.london}>
            <Image
              src="/assets/icons/london.svg"
              fill
              loading="lazy"
              alt={"london"}
            />
          </div>
          <div className={styles.nass}>
            <Image
              src="/assets/icons/nasscom.svg"
              fill
              loading="lazy"
              alt={"london"}
            />
          </div>
          <Link
            prefetch={false}
            href="https://www.goodfirms.co/company/cubet-techno-labs"
            target="_blank"
            rel="nofollow"
            className={styles.goodFirm}
          >
            <Image
              loading="lazy"
              src="/assets/icons/good-firm.svg"
              alt="rating"
              fill
            />
          </Link>
          <Link
            prefetch={false}
            href="https://clutch.co/profile/cubet"
            target="_blank"
            rel="nofollow"
            className={styles.clutch}
          >
            <Image
              src="/assets/icons/clutch.svg"
              loading="lazy"
              alt="rating"
              fill
            />
          </Link>

        </div>
      </div>
    </div>
  );
};

export default FooterLatest;
